import { Injectable } from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router} from '@angular/router';
import { Observable } from 'rxjs';
import { NgBlockUI, BlockUI } from 'ng-block-ui';
import { CommonHelperService } from './common-helper.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  @BlockUI() blockUI: NgBlockUI;
  constructor(private route: Router,private commonHelper:CommonHelperService) {
    
  }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      this.blockUI.stop();
    if (this.isLoggedIn()) {
      return true;
    } else {
      this.route.navigate(['/login']);
      return false;
    }
  }
  isLoggedIn() {
    return localStorage.getItem('authToken') ? true : false;
  }
}
